export const GAMIFICATION_ROUTES = {
  start: '/gamification',
  subjects: '/gamification/subjects',
  attempts: '/gamification/attempts',
  selectBattle: '/gamification/battles/select',
  leaderboard: '/gamification/leaderboard',
  battleLeaderboard: '/gamification/battles/leaderboard',
  answerSheet: '/gamification/battles/answer-sheet',
  coinStore: '/gamification/coin-store',
  coinHistory: '/gamification/coin-history',
  playFriends: '/gamification/battles/friends',
  groupWaiting: '/gamification/battles/group/waiting',
  singleWaiting: '/gamification/battles/single/waiting',
  liveBattle: '/gamification/battles/live',
  detail: '/gamification/battles/detail',
  battleResult: '/gamification/battles/result',
  scoreboard: '/gamification/battles/scoreboard',
  groupBattleCard: '/gamification/battles/group/card',
};
